import { useState } from 'react'
import moment from 'moment'
import { useMutation } from 'react-query'

// Constants
import { DASHED_DATE_FORMAT } from 'common/constants/dateFormat'

// Services
import { GetDailyAlerts } from 'services/api/Alerts'

export default () => {
  // States
  const [dailyAlertsData, setDailyAlertsData] = useState({
    labels: [],
    datasets: [
      {
        backgroundColor: '#cbcbcb',
        data: [],
        label: 'Daily Activity',
      },
    ],
  })

  // Hooks
  const {
    mutate: getDailyAlerts,
    error: dailyAlertsError,
    isLoading: isDailyAlertsLoading,
    isSuccess: isDailyAlertsSuccess,
    isError: isDailyAlertsError,
  } = useMutation(GetDailyAlerts, {
    onSuccess: (data, params) => {
      const chartData = getDates(data, params)

      const labels = chartData.map((o) => o.label)
      const values = chartData.map((o) => o.count)
      setDailyAlertsData({
        labels,
        datasets: [
          {
            label: 'Daily Activity',
            data: values,
            backgroundColor: '#cbcbcb',
          },
        ],
      })
    },
  })

  // Functions
  const getDates = (data, params) => {
    const { start_range, end_range } = params

    const days = []

    let currentDate = moment(start_range || moment().subtract(30, 'days'))
    const stopDate = moment(end_range || moment().add(1, 'days'))

    while (currentDate <= stopDate) {
      days.push({
        label: moment(currentDate).format(DASHED_DATE_FORMAT),
      })
      currentDate = moment(currentDate).add(1, 'days')
    }

    const copyArr = days

    data.forEach((result) => {
      copyArr.forEach((item, i) => {
        if (result.alert_date === item.label) {
          days[i].count = result.alert_count
        }
      })
    })

    days.forEach((item, i) => {
      if (item.count === undefined) {
        days[i].count = 0
      }
    })

    return days
  }

  return {
    getDailyAlerts,
    dailyAlertsData,
    dailyAlertsError,
    isDailyAlertsLoading,
    isDailyAlertsSuccess,
    isDailyAlertsError,
  }
}
